<template>
  <path :d="d" stroke="#404040" />
</template>
<script>
export default {
  name: "LineAxis",
  computed: {
    d() {
      return `M${this.centerPoint.x},${this.centerPoint.y} L${this.point.x},${this.point.y}`;
    },
  },
  props: {
    point: Object,
    centerPoint: Object,
  },
};
</script>